import { render } from "./newsletter.vue?vue&type=template&id=3889e715"
import script from "./newsletter.vue?vue&type=script&lang=js"
export * from "./newsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__